import React from "react";
import {connect} from "react-redux";
import Header from "../components/Header";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

const HeaderContainer = () => {
    return (
        <div>
            <Header/>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);


// WEBPACK FOOTER //
// ./src/container/HeaderContainer.js